import { AuthService } from './../services/auth.service';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private _authService: AuthService,
        private _router: Router
    ) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const userToken = this._authService.userToken;
        const isOptionalSessionRequest =
            req.method === 'GET' &&
            req.url.includes('/api/PriceList/Client/') &&
            req.url.includes('/Default');

        if (userToken) {
            if (this._authService.isTokenExpired(userToken)) {
                this._authService.logout(false);
                this._authService.redirectToGoogleLogin(this._router.url);
                return throwError(() => new Error('Token expirado'));
            }
            req = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${userToken}`
                }
            });
        }

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    if (!isOptionalSessionRequest && this._router.url !== '/login') {
                        this._authService.logout(false);
                        this._authService.redirectToGoogleLogin(this._router.url);
                    }
                }
                return throwError(() => error);
            })
        );
    }
}
